var _excluded = ["size", "color", "onClick", "cursor", "display", "data-test-name", "aria-label"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import * as React from "react"; // DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using iconTemplate.js Please refer to web/src/nessie/icons/README.md for more details

import { nessiePropCheckerWrapper } from "../../nessiePropCheckerWrapper";
import { colorNessieResponsivePropType, oneOfNessieResponsivePropType } from "../../propTypes";
import UnstyledButton from "../../../../components/buttons/UnstyledButton";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
import { jsxs as _jsxs } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var GlobeIcon = function GlobeIcon(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? "m" : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? "shale" : _ref$color,
    onClick = _ref.onClick,
    cursor = _ref.cursor,
    _ref$display = _ref.display,
    display = _ref$display === void 0 ? "inline-block" : _ref$display,
    dataTestName = _ref["data-test-name"],
    ariaLabel = _ref["aria-label"],
    props = _objectWithoutProperties(_ref, _excluded);
  var sizeInPixels = SIZES[size];
  var ButtonOrSpan = onClick ? UnstyledButton : "span";
  return _jsx(ButtonOrSpan, {
    "aria-label": ariaLabel,
    "data-test-name": dataTestName,
    onClick: onClick,
    sx: {
      fontSize: sizeInPixels,
      display: display,
      lineHeight: 0,
      color: color,
      cursor: cursor,
      position: "relative"
    },
    children: _jsxs("svg", _objectSpread(_objectSpread({
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {}, {
      children: [_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2C6.494 2 2 6.494 2 12s4.494 10 10 10 10-4.494 10-10c-.04-5.506-4.494-10-10-10zm0 18.583c-2.51 0-4.777-1.093-6.356-2.793.08-.203.486-1.418.769-1.984.324-.608.405-.689 1.093-1.296.688-.607-1.376-.89-1.862-1.376-.486-.486-.729-.486-1.255-.932-.405-.323-.648 1.134-.73 1.863a8.398 8.398 0 01-.242-2.024c0-1.822.567-3.523 1.538-4.9-.283.85-.526 2.065.527 1.701 1.174-.405 1.255-.89 1.255-.89l.688-1.215s.122 1.66.243 1.903c.121.243.688.93.89-.04.365-1.782.446-2.268 1.094-2.268.648 0 1.984-.526 2.146 1.053.121 1.579-.122.647-1.013 1.052-.85.405-1.052 1.863-.283 2.024.77.162 2.591.891 2.591.891l.89 1.012.284 1.053s.162 1.215.162 1.296v1.093s.04 2.145.81 1.66c.77-.527 2.955-3.887 2.51-5.142-.445-1.255-.486-1.417.324-1.863.81-.445 1.417-1.012 1.376-1.619-.04-.445 0-.688.04-.972.649 1.215 1.053 2.632 1.053 4.09 0 4.777-3.846 8.623-8.542 8.623z"
      }), _jsx("mask", {
        maskUnits: "userSpaceOnUse",
        x: 2,
        y: 2,
        width: 20,
        height: 20,
        children: _jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 2C6.494 2 2 6.494 2 12s4.494 10 10 10 10-4.494 10-10c-.04-5.506-4.494-10-10-10zm0 18.583c-2.51 0-4.777-1.093-6.356-2.793.08-.203.486-1.418.769-1.984.324-.608.405-.689 1.093-1.296.688-.607-1.376-.89-1.862-1.376-.486-.486-.729-.486-1.255-.932-.405-.323-.648 1.134-.73 1.863a8.398 8.398 0 01-.242-2.024c0-1.822.567-3.523 1.538-4.9-.283.85-.526 2.065.527 1.701 1.174-.405 1.255-.89 1.255-.89l.688-1.215s.122 1.66.243 1.903c.121.243.688.93.89-.04.365-1.782.446-2.268 1.094-2.268.648 0 1.984-.526 2.146 1.053.121 1.579-.122.647-1.013 1.052-.85.405-1.052 1.863-.283 2.024.77.162 2.591.891 2.591.891l.89 1.012.284 1.053s.162 1.215.162 1.296v1.093s.04 2.145.81 1.66c.77-.527 2.955-3.887 2.51-5.142-.445-1.255-.486-1.417.324-1.863.81-.445 1.417-1.012 1.376-1.619-.04-.445 0-.688.04-.972.649 1.215 1.053 2.632 1.053 4.09 0 4.777-3.846 8.623-8.542 8.623z"
        })
      })]
    }))
  });
};
var SIZES = {
  xs: "12px",
  s: "18px",
  m: "24px",
  l: "36px",
  xl: "48px",
  xxl: "56px"
};
GlobeIcon.nessiePropTypes = {
  color: colorNessieResponsivePropType,
  size: oneOfNessieResponsivePropType(["xs", "s", "m", "l", "xl", "xxl"])
}; // ------------------------------------------
// ------------------------------------------
// DEV ONLY better prop checking

if (process.env.NODE_ENV === "development") {
  GlobeIcon = nessiePropCheckerWrapper(GlobeIcon);
}
export default GlobeIcon;